export default {"src":"/_next/static/media/whatsapp-follow-icon.ca299518.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};